var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar16W(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7619 12.8H3.2381V6.2H12.7619M10.9048 2V3.2H5.09524V2H3.85714V3.2H3.2381C2.55095 3.2 2 3.734 2 4.4V12.8C2 13.1183 2.13044 13.4235 2.36263 13.6485C2.59482 13.8736 2.90973 14 3.2381 14H12.7619C13.0903 14 13.4052 13.8736 13.6374 13.6485C13.8696 13.4235 14 13.1183 14 12.8V4.4C14 4.08174 13.8696 3.77652 13.6374 3.55147C13.4052 3.32643 13.0903 3.2 12.7619 3.2H12.1429V2",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar16W);
export default __webpack_public_path__ + "static/media/Calendar_16w.da2776ba3536775cfb6c9f960087c226.svg";
export { ForwardRef as ReactComponent };